import { prettifyJsoncString } from "../helpers/prettify-jsonc-string.js";
import { computed, createCommentVNode, createElementBlock, createElementVNode, createVNode, defineComponent, openBlock, ref, toRef, unref, useId } from "vue";
import { ScalarIconArrowElbowDownLeft } from "@scalar/icons";
import { ScalarIconButton } from "@scalar/components/icon-button";
import { EditorView, useCodeMirror } from "@scalar/use-codemirror";
import { ScalarCodeBlockCopy } from "@scalar/components/code-block";
//#region src/v2/blocks/response-block/components/ResponseBodyRaw.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1 = {
	class: "scalar-code-block group/code-block relative grid min-h-0 overflow-hidden p-px outline-none has-focus-visible:outline",
	"data-testid": "response-body-raw"
};
var _hoisted_2 = {
	class: "custom-scroll relative pr-1",
	tabindex: "0"
};
var _hoisted_3 = {
	key: 0,
	class: "absolute top-2 right-2 flex items-center gap-1.5 opacity-0 transition-opacity duration-150 group-hover/code-block:opacity-100 group-has-focus-visible/code-block:opacity-100"
};
var ResponseBodyRaw_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	__name: "ResponseBodyRaw",
	props: {
		content: {},
		language: {},
		prettyPrintJson: { type: Boolean }
	},
	setup(__props) {
		const props = __props;
		const codeMirrorRef = ref(null);
		/** Base id for the code block */
		const id = useId();
		const isLineWrapping = ref(false);
		const displayContent = computed(() => {
			const { content, language, prettyPrintJson = false } = props;
			if (typeof content !== "string") {
				if (content == null) return "";
				return String(content);
			}
			if (prettyPrintJson && language === "json") return prettifyJsoncString(content);
			return content;
		});
		const extensions = computed(() => isLineWrapping.value ? [EditorView.lineWrapping] : []);
		const { codeMirror } = useCodeMirror({
			codeMirrorRef,
			readOnly: true,
			lineNumbers: true,
			content: toRef(displayContent),
			language: toRef(() => props.language),
			forceFoldGutter: true,
			extensions
		});
		const getCurrentContent = () => {
			return codeMirror.value?.state.doc.toString() || "";
		};
		const toggleLineWrapping = () => {
			isLineWrapping.value = !isLineWrapping.value;
		};
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("div", _hoisted_2, [createElementVNode("div", {
				ref_key: "codeMirrorRef",
				ref: codeMirrorRef
			}, null, 512)]), getCurrentContent() ? (openBlock(), createElementBlock("div", _hoisted_3, [createVNode(unref(ScalarIconButton), {
				"aria-label": isLineWrapping.value ? "Disable line wrap" : "Wrap lines",
				"aria-pressed": isLineWrapping.value,
				class: "bg-b-2 text-c-2 hover:text-c-1 absolute right-18",
				icon: unref(ScalarIconArrowElbowDownLeft),
				label: isLineWrapping.value ? "Disable line wrap" : "Wrap lines",
				size: "sm",
				tooltip: "",
				variant: "ghost",
				onClick: toggleLineWrapping
			}, null, 8, [
				"aria-label",
				"aria-pressed",
				"icon",
				"label"
			]), createVNode(unref(ScalarCodeBlockCopy), {
				"aria-controls": unref(id),
				content: getCurrentContent()
			}, null, 8, ["aria-controls", "content"])])) : createCommentVNode("", true)]);
		};
	}
});
//#endregion
export { ResponseBodyRaw_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=ResponseBodyRaw.vue.script.js.map